import * as React from 'react';
import './QAEmailTemplatePage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { IStandardEmailTemplateReduxFormState, initialStandardEmailTemplateState } from "../../../reducers/reactReduxForms/standardEmailTemplate";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, NumberFormInput, CheckboxFormInput, SelectFormInput, TextAreaFormInput } from "../../../components/form/index";
import * as StandardEmailTemplateActions from '../../../actions/standardEmailTemplates';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { NotificationAlert } from "../../../components/common/index";
import { Form, actions } from 'react-redux-form';
import { QALookupsLayout } from '../../index';
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import * as AuthenticationHelper from '../../../helpers/authentication';

interface IQAEmailTemplatePageParams {
    standardEmailTemplateId: number;
}

interface IQAEmailTemplatePageProps {

    form: Dtos.StandardEmailTemplate & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: IStandardEmailTemplateReduxFormState;

    location: Location;
    standardEmailTemplateId: number;
    match: match<IQAEmailTemplatePageParams>;
    history: History;

    // From state
    standardEmailTemplate: Dtos.StandardEmailTemplate;
    lookups: Dtos.Lookup[];

    loadingStandardEmailTemplate: boolean;
    loadStandardEmailTemplateSuccess: boolean;
    loadStandardEmailTemplateFailure: boolean;

    savingStandardEmailTemplate: boolean;
    saveStandardEmailTemplateSuccess: boolean;
    saveStandardEmailTemplateFailure: boolean;

    creatingStandardEmailTemplate: boolean;
    createStandardEmailTemplateSuccess: boolean;
    createStandardEmailTemplateFailure: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface IQAEmailTemplatePageActions {
    clearStandardEmailTemplate: StandardEmailTemplateActions.IStandardEmailTemplateClearActionCreator;
    loadStandardEmailTemplate: StandardEmailTemplateActions.IStandardEmailTemplateLoadByIdActionCreator;

    saveStandardEmailTemplate: StandardEmailTemplateActions.IStandardEmailTemplateSaveActionCreator;
    createStandardEmailTemplate: StandardEmailTemplateActions.IStandardEmailTemplateCreateActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;
}

type QAEmailTemplatePageProps = IQAEmailTemplatePageProps & IQAEmailTemplatePageActions;

const reduxFormName: string = "reduxForms.standardEmailTemplate";

class QAEmailTemplatePage extends React.PureComponent<QAEmailTemplatePageProps, any> {

    constructor(props: QAEmailTemplatePageProps) {
        super(props);

        this.clearStandardEmailTemplate = this.clearStandardEmailTemplate.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
    }

    componentDidMount() {
        const {
            loadStandardEmailTemplate,
            standardEmailTemplateId,
            createStandardEmailTemplate
        } = this.props;

        if (standardEmailTemplateId) {
            loadStandardEmailTemplate(standardEmailTemplateId);
        } else if (!standardEmailTemplateId) {
            createStandardEmailTemplate();
        }
    }

    componentDidUpdate(prevProps: QAEmailTemplatePageProps, prevState) {
        const {
            standardEmailTemplateId,
            standardEmailTemplate,
            form,
            navigate,
            loadStandardEmailTemplate,
            loadingStandardEmailTemplate,
            loadStandardEmailTemplateSuccess,
            createStandardEmailTemplate,
            creatingStandardEmailTemplate,
            createStandardEmailTemplateSuccess,
            savingStandardEmailTemplate,
            saveStandardEmailTemplateSuccess,
            validationFailures
        } = this.props;

        if (standardEmailTemplateId && prevProps.standardEmailTemplateId != standardEmailTemplateId) {
            loadStandardEmailTemplate(standardEmailTemplateId);
        }
        else if (!standardEmailTemplateId && prevProps.standardEmailTemplateId) {
            createStandardEmailTemplate();
        }

        if (!loadingStandardEmailTemplate && prevProps.loadingStandardEmailTemplate) {
            if (loadStandardEmailTemplateSuccess) {
                this.loadForm();
            }
        }

        if (!savingStandardEmailTemplate && prevProps.savingStandardEmailTemplate) {
            if (saveStandardEmailTemplateSuccess) {
                if (validationFailures && validationFailures.length > 0) {
                    Alert.warning(<NotificationAlert
                        alertContent={renderRegistrationFormSaveWarning(validationFailures)}
                        icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                    />);

                } else {
                    Alert.success(<NotificationAlert
                        alertContent={renderRegistrationFormSaveSuccess()}
                        icon={FontAwesomeIcons.Solid.CHECK}
                    />);
                }
                if (form.saveAndReturn) {
                    navigate("/settings/qa/qaEmailTemplates")
                } else if (!form.saveAndReturn && standardEmailTemplateId && standardEmailTemplateId > 0) {
                    this.loadForm();
                } else if (!form.saveAndReturn && !standardEmailTemplateId && standardEmailTemplate && standardEmailTemplate.id > 0) {
                    navigate("/settings/qa/qaEmailTemplates/" + standardEmailTemplate.id);
                }
            }
            else {
                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );
            }
        }

        if (!creatingStandardEmailTemplate && prevProps.creatingStandardEmailTemplate) {
            if (createStandardEmailTemplateSuccess) {
                this.loadForm();
            }
        }
    }

    componentWillUnmount() {
        const {
            resetForm,
            loadForm
        } = this.props

        this.clearStandardEmailTemplate();
        loadForm(reduxFormName, initialStandardEmailTemplateState);
        resetForm(reduxFormName);
    }

    clearStandardEmailTemplate() {
        this.props.clearStandardEmailTemplate();
    }

    showStandardEmailTemplate(): boolean {
        const {
            loadingStandardEmailTemplate,
            loadStandardEmailTemplateSuccess
        } = this.props

        if (!loadingStandardEmailTemplate && loadStandardEmailTemplateSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingStandardEmailTemplate
        } = this.props;

        return <QALookupsLayout loading={loadingStandardEmailTemplate} permission={Dtos.Permission.QAEmailTemplatesView}>
            {this.renderContent()}
        </QALookupsLayout>;
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            savingStandardEmailTemplate,
            permissions
        } = this.props;

        const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.QAEmailTemplatesUpdate, Dtos.Permission.QAEmailTemplatesCreate);
        const formDisabled: boolean = !hasPermission || savingStandardEmailTemplate || (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            value: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
            },
            rank: {
                type: RegistrationComponent.RegistrationControl,
                inputType: NumberFormInput,
                inputDisabled: formDisabled,
            },
            standardEmailTypeId: {
                type: RegistrationComponent.RegistrationControl,
                inputType: SelectFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    options: generateOptionsFromLookup(findLookup("StandardEmailTemplate", "StandardEmailTypeId", lookups), form.standardEmailTypeId)
                },
                changeAction: (model, value, form, parentModel) => {
                    changeForm(model, value);
                    changeForm(reduxFormName + ".standardEmailType", null);
                },
            },
            subject: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
            },
            body: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextAreaFormInput,
                inputDisabled: formDisabled,
            },
            active: {
                type: RegistrationComponent.RegistrationControl,
                inputType: CheckboxFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    label: "Active"
                },
                inputLabel: " ",
            }
        };

        return <div>
            <h1>Email Template</h1>
            <Form model={reduxFormName}
                onSubmit={(val, event) => this.handleOnSubmit(val)}
                onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
            >
                {
                    renderFormControls(form, "standardEmailTemplate", formComponents, lookups, validationFailures, formProperties, changeForm)
                }
                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled}
                        onClick={
                            () => {
                                this.props.changeForm(reduxFormName + ".saveAndReturn", false);
                            }
                        }
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>

                    <button disabled={formDisabled}
                        onClick={() => {
                            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2" > Cancel </button>
                </div>
            </Form>

        </div>

    }

    renderErrorAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was <strong> not </strong> saved.
            </div>

    }

    renderWarningAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>

    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>
    }

    handleOnSubmit(data: Dtos.StandardEmailTemplate) {
        const {
            saveStandardEmailTemplate
        } = this.props;

        if (data) {
            let changes: Dtos.StandardEmailTemplate = {} as Dtos.StandardEmailTemplate;
            saveStandardEmailTemplate(Object.assign({ ...data }, changes));
        }
    }


    handleOnSubmitFailed(data: Dtos.StandardEmailTemplate) {
        Alert.error(<NotificationAlert
            minWidth={500}
            alertContent={renderRegistrationFormSaveBlock()}
            icon={FontAwesomeIcons.Solid.BAN}
        />);
    }

    onCancel() {
        const {
            navigate
        } = this.props;

        navigate("/settings/qa/qaEmailTemplates");
    }

    loadForm() {
        const {
            loadForm,
            standardEmailTemplate,
        } = this.props

        let extraData: Dtos.StandardEmailTemplate = {} as Dtos.StandardEmailTemplate;

        loadForm(reduxFormName, Object.assign({ ...standardEmailTemplate }, extraData));
    }

}


const mapStateToProps = (state: ITmdState, ownProps: QAEmailTemplatePageProps): IQAEmailTemplatePageProps => {

    let standardEmailTemplate: Dtos.StandardEmailTemplate | undefined = !(state.standardEmailTemplates.formData instanceof Array) ? state.standardEmailTemplates.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        match: ownProps.match,
        standardEmailTemplateId: ownProps.match && ownProps.match.params.standardEmailTemplateId && ownProps.match.params.standardEmailTemplateId.toString() != "create" ? ownProps.match.params.standardEmailTemplateId : undefined!,

        history: ownProps.history,
        location: state.routing.location,

        standardEmailTemplate: standardEmailTemplate!,

        loadingStandardEmailTemplate: state.standardEmailTemplates.loadState && state.standardEmailTemplates.loadState.status == RequestState.Pending,
        loadStandardEmailTemplateSuccess: state.standardEmailTemplates.loadState && state.standardEmailTemplates.loadState.status == RequestState.Success,
        loadStandardEmailTemplateFailure: state.standardEmailTemplates.loadState && state.standardEmailTemplates.loadState.status == RequestState.Failure,

        savingStandardEmailTemplate: state.standardEmailTemplates.saveState && state.standardEmailTemplates.saveState.status == RequestState.Pending,
        saveStandardEmailTemplateSuccess: state.standardEmailTemplates.saveState && state.standardEmailTemplates.saveState.status == RequestState.Success,
        saveStandardEmailTemplateFailure: state.standardEmailTemplates.saveState && state.standardEmailTemplates.saveState.status == RequestState.Failure,

        creatingStandardEmailTemplate: state.standardEmailTemplates.createState && state.standardEmailTemplates.createState.status == RequestState.Pending,
        createStandardEmailTemplateSuccess: state.standardEmailTemplates.createState && state.standardEmailTemplates.createState.status == RequestState.Success,
        createStandardEmailTemplateFailure: state.standardEmailTemplates.createState && state.standardEmailTemplates.createState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        lookups: state.standardEmailTemplates.lookups,

        form: state.reduxForms.standardEmailTemplate,
        formState: state.standardEmailTemplates.formState,
        formProperties: state.standardEmailTemplates.formProperties,

        reduxFormState: state.reduxForms.formState.standardEmailTemplate,
        validationFailures: standardEmailTemplate ?
            state.standardEmailTemplates.validationFailures :
            undefined,
    };
};

const mapDispatchToProps = (dispatch): IQAEmailTemplatePageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadStandardEmailTemplate: bindActionCreators(StandardEmailTemplateActions.LoadStandardEmailTemplateById, dispatch),
        clearStandardEmailTemplate: bindActionCreators(StandardEmailTemplateActions.Clear, dispatch),

        saveStandardEmailTemplate: bindActionCreators(StandardEmailTemplateActions.SaveStandardEmailTemplate, dispatch),
        createStandardEmailTemplate: bindActionCreators(StandardEmailTemplateActions.CreateStandardEmailTemplate, dispatch),

    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(QAEmailTemplatePage);
